export default __webpack_public_path__ + "static/media/dictionary 2.af7856d8.PNG";